import { useArtwork } from "@design-lab/entities/artwork";
import { useProcessingTooltip } from "@design-lab/shared/hooks/useProcessingTooltip";
import { useExperiments } from "@design-lab/shared/lib/config";
import { shouldReorderDesignLabTabs } from "@design-lab/shared/lib/experiments";
import { Button } from "@design-lab/shared/ui";
import { Tooltip, TooltipTrigger } from "@design-lab/shared/ui/design-system/Tooltip";
import { useTab } from "@design-lab/shared/ui/layouts/state";
import { ChevronRight } from "lucide-react";

type NextButtonProps = {
  className?: string;
};

export function NextButton(props: NextButtonProps) {
  const { className } = props;
  const { tab, nextTab, isValid, canGoNext, next } = useTab();

  const { front, back } = useArtwork();

  const experiments = useExperiments();
  const showSubTabs = shouldReorderDesignLabTabs(experiments?.abDesignLabReorderTabs);

  const frontHasLoading = front.state.hasTag("loading");
  const backHasLoading = back.state.hasTag("loading");

  const shouldShowTooltip = (frontHasLoading || backHasLoading) && tab === "upload";

  const { showTooltip, dismissTooltip } = useProcessingTooltip({
    shouldShow: shouldShowTooltip,
    enableTooltip: !showSubTabs
  });

  if (!canGoNext || !nextTab) return null;

  return (
    <TooltipTrigger isOpen={showTooltip}>
      <Button
        data-testid="next-button"
        variant="destructive"
        className={className ?? ""}
        isDisabled={!isValid}
        onPress={next}
      >
        Next: {nextTab.mobileTitle} <ChevronRight />
      </Button>
      <Tooltip
        placement="bottom end"
        onClose={dismissTooltip}
        className="bg-blue-700 p-4"
        arrowClassName="fill-blue-700"
      >
        <p className="text-sm">
          While the image is being processed continue to add colors and more products.
        </p>
      </Tooltip>
    </TooltipTrigger>
  );
}
